import { difference } from 'ramda';

export function removeFromTermsValue<T>({ terms, removeTerms }: { terms: Array<T>; removeTerms: Array<T> }) {
  return difference(terms, removeTerms);
}
